import { generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

type Props = {
	hotelID: string;
};

export const HeaderInner = ({ hotelID }: Props) => {
	return (
		<div className="max-w-screen-screen relative mx-auto p-4 desktop:px-12 desktop:pb-5 desktop:pt-12">
			<div className="space-y-6">
				<div className="text-sm">
					<p>・ゲストに送付されるメールの文言と、送る / 送らないを設定できます</p>
					<p>
						・プラン別にメールの文言を変えることもできます。「商品管理」内の
						<a
							href={generatePath(PATHS.HOTEL.ITEMS.PLAN.TOP, { hotelID })}
							className="ml-1 text-blue-600 underline"
						>
							プラン編集ページ
						</a>
						から設定できます
					</p>
					<p>
						・リクエスト予約を承認した際のメールを編集したい場合は、右のサイドメニューのリクエスト予約ページから設定できます
					</p>
				</div>
			</div>
		</div>
	);
};
